// Theme toggle (ledger row 20). data-theme on <html>, persisted to
// localStorage; init happens early in index.js so there's no flash.
import React from 'react';

export const THEME_KEY = 'adaptiq.theme';

export function initTheme() {
  let theme = 'light';
  try {
    theme = localStorage.getItem(THEME_KEY)
      || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  } catch { /* default */ }
  document.documentElement.setAttribute('data-theme', theme);
  return theme;
}

export default function ThemeToggle() {
  const [theme, setTheme] = React.useState(
    () => document.documentElement.getAttribute('data-theme') || 'light',
  );
  const apply = (t) => {
    setTheme(t);
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem(THEME_KEY, t); } catch { /* non-fatal */ }
  };
  return (
    <div className="seg" role="group" aria-label="theme">
      <button type="button" aria-pressed={theme === 'light'} onClick={() => apply('light')}>Light</button>
      <button type="button" aria-pressed={theme === 'dark'} onClick={() => apply('dark')}>Dark</button>
    </div>
  );
}
